import { render } from "./FixedBtns.vue?vue&type=template&id=361e3607&scoped=true"
import script from "./FixedBtns.vue?vue&type=script&lang=js"
export * from "./FixedBtns.vue?vue&type=script&lang=js"

import "./FixedBtns.vue?vue&type=style&index=0&id=361e3607&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-361e3607"]])

export default __exports__